import {i18nKey} from '@/locales/i18n';
import IconView from '@/assets/icons/ic_view.svg';
import IconShare from '@/assets/icons/ic_share.svg';
import IconDelete from '@/assets/icons/ic_delete.svg';
import IconEdit from '@/assets/icons/ic_edit_gray.svg';
import IconDuplicate from '@/assets/icons/ic_duplicate.svg';

export const DEFAULT_VALUE = {
  tab: '0',
  value: 0,
};

export const ROW_TABLE = {
  count_index: 1,
  count_index_new: 2,
};

export enum TEMPLATE_KEY {
  nameTemplate = 'template',
  searchTemplate = 'search',
  categoryTemplate = 'category',
}

export const ACTIVATE_KEY_TAB = {
  template: 'template',
  document_set: 'document_set',
};

export enum DETECTION_KEY {
  next = 'next',
  previous = 'previous',
  last = 'last',
  first = 'first',
}

export enum MODAL_TYPE {
  create = 'create',
  edit = 'edit',
}

export const ITEM_STATUS_TEMPLATE = [
  {value: '1', label: () => i18nKey.Status.Template.all},
  {value: '2', label: () => i18nKey.Status.Template.standard},
  {value: '3', label: () => i18nKey.Status.Template.custom},
];

export const ITEM_ACTION_ADMIN = [
  {
    key: '1',
    label: () => i18nKey.templateScreen.listTemplate.actionText.view,
    icon: IconView,
  },
  {
    key: '2',
    label: () => i18nKey.templateScreen.listTemplate.actionText.edit,
    icon: IconEdit,
  },
  {
    key: '3',
    label: () => i18nKey.templateScreen.listTemplate.actionText.assignTo,
    icon: IconShare,
  },
  {
    key: '4',
    label: () => i18nKey.templateScreen.listTemplate.actionText.duplicate,
    icon: IconDuplicate,
  },
  {
    key: '5',
    label: () => i18nKey.templateScreen.listTemplate.actionText.delete,
    icon: IconDelete,
  },
];

export const ITEM_ACTION_USER = [
  {
    key: '1',
    label: () => i18nKey.templateScreen.listTemplate.actionText.view,
    icon: IconView,
  },
  {
    key: '2',
    label: () => i18nKey.templateScreen.listTemplate.actionText.edit,
    icon: IconEdit,
  },
  {
    key: '3',
    label: () => i18nKey.templateScreen.listTemplate.actionText.share,
    icon: IconShare,
  },
  {
    key: '4',
    label: () => i18nKey.templateScreen.listTemplate.actionText.duplicate,
    icon: IconDuplicate,
  },
  {
    key: '5',
    label: () => i18nKey.templateScreen.listTemplate.actionText.delete,
    icon: IconDelete,
  },
];

export const ITEM_ACTION_DOCUMENT_SET = [
  {
    key: '1',
    label: () => i18nKey.templateScreen.listTemplate.actionText.edit,
    icon: IconEdit,
  },
  // {
  //   key: '2',
  //   label: () => i18nKey.templateScreen.listTemplate.actionText.duplicate,
  //   icon: IconDuplicate,
  // },
  {
    key: '3',
    label: () => i18nKey.templateScreen.listTemplate.actionText.delete,
    icon: IconDelete,
  },
];

export enum MENU_KEY_TEMPLATE_ADMIN {
  view = '1',
  edit = '2',
  assignTo = '3',
  duplicate = '4',
  delete = '5',
}

export enum MENU_KEY_TEMPLATE_USER {
  view = '1',
  edit = '2',
  share = '3',
  duplicate = '4',
  delete = '5',
}

export enum MENU_KEY_DOCUMENT_SET {
  edit = '1',
  duplicate = '2',
  delete = '3',
}

export const TEMPLATE_FORM_MODAL_ASSIGN = {
  selected: 'selected',
  txtSearch: 'txtSearch',
};

export const TEMPLATE_FILTER = {
  SEARCH: 'search',
  CREATED_BY: 'createdBy',
};

export enum TEMPLATE_FORM_COMPONENT {
  NAME = 'name',
  CATEGORY = 'category',
  DESCRIPTION = 'description',
}

export enum TYPE_FILTER_CONFIDEN_SCORE {
  HIGH = 'high',
  LOW = 'low',
}

export const SCORE_STANDARD = Number(process?.env?.REACT_APP_CONFIDENCE_SCORE_THRESHOLD ?? 70);

export const LANGUAGE_TEMPLATE = {
  en: () => i18nKey.templateScreen.popupSyncTemplate.language.en,
  jp: () => i18nKey.templateScreen.popupSyncTemplate.language.jp,
  vn: () => i18nKey.templateScreen.popupSyncTemplate.language.vn,
};

export const STATUS_TEMPLATE = {
  New: () => i18nKey.templateScreen.popupSyncTemplate.status.new,
  Updated: () => i18nKey.templateScreen.popupSyncTemplate.status.updated,
  NotChanged: () => i18nKey.templateScreen.popupSyncTemplate.status.notChanged,
};
